let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8VNfe")).then(() => parcelRequire('kUaFt'));